import type { IconData } from '@stacksjs/iconify-core'

export const envelope: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M348 250q22 6 45 0l348-87v371q0 10-6 16t-17 7H23q-10 0-16-7t-7-16V163zM718 1q10 0 17 6t6 17v70l-348 87q-23 5-45 0L0 94V24Q0 14 7 7t16-6z\"/>",
  "width": 750,
  "height": 750,
  "viewBox": "0 0 750 750"
}

export default envelope
